import { render, staticRenderFns } from "./BatchConfirm.vue?vue&type=template&id=80e523fc&"
import script from "./BatchConfirm.vue?vue&type=script&lang=ts&"
export * from "./BatchConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports